module.exports = __webpack_public_path__ + "img/Daikin_Footer.3dd7ee37.png";